
export { default as NavBar } from './NavBar';
export { default as NavBarCashier } from './NavBarCashier';
export { default as DetailsItemSale } from './DetailsItemSale';
export { default as BillModal } from './BillModal';
export { default as RefundModal } from './RefundModal';
export { default as WithdrawalModal } from './WithdrawalModal';
export { default as InventoryModal } from './InventoryModal';
export { default as SalesModal } from './SalesModal';
export { default as CashCutModal } from './CashCutModal';
// export { default as ReportSaleModal } from './ReportSaleModal';
export { default as SavedSalesModal } from './SavedSalesModal';
export { default as SearchModal } from './SearchModal';
export { default as SearchStockModal } from './SearchStockModal';
export { default as TicketModal } from './TicketModal';
export { default as FormatDeliveryModal } from './FormatDeliveryModal';
export { default as TicketDeliveryModal } from './TicketDeliveryModal';
export { default as FormatTicketModal } from './FormatTicketModal';
export { default as RefSaleModal } from './RefSaleModal';
export { default as RefMoveCashModal } from './RefMoveCashModal';
export { default as InitialCashModal } from './InitialCashModal';
export { default as ClientsModal } from './ClientsModal';
export { default as DetailClientModal } from './DetailClientModal';
export { default as TerminalFunctions } from './TerminalFunctions';
export { default as NewClientModal } from './NewClientModal';
export { default as CashInModal } from './CashInModal';
export { default as CashOutModal } from './CashOutModal';
export { default as DepositModal } from './DepositModal';
export { default as TaxesModal } from './TaxesModal';
export { default as SelectAddressModal } from './SelectAddressModal';
export { default as NewAddressModal } from './NewAddressModal';
export { default as InvoiceDataModal } from './InvoiceDataModal';
export { default as FormatQuotationModal } from './FormatQuotationModal';
export { default as FormatOrderSaleModal } from './FormatOrderSaleModal';
export { default as FormatInvoiceModal } from './FormatInvoiceModal';
export { default as FormatCancelationModal } from './FormatCancelationModal';
export { default as PartialPaymentModal } from './PartialPaymentModal';
export { default as CollectModal } from './CollectModal';
export { default as SaleDetailsModal } from './SaleDetailsModal';
export { default as GrossProfitModal } from './GrossProfitModal';
export { default as EMailAddressModal } from './EMailAddressModal';
export { default as Pagination } from './Pagination';
export { default as BreadCumb } from './BreadCumb';
export { default as DataTables } from './DataTables';
export { default as DataTablesCreate } from './DataTablesCreate';
export { default as TimeOut } from './Timeout';
export { default as BusinessPartnerFields } from './BusinessPartnerFields';
export { default as ItemDataFields } from './ItemDataFields';
export { default as CollectionModal } from './CollectionModal';
export { default as ConsolidateDocsModal } from './ConsolidateDocsModal';
export { default as DocumentCreateModal } from './DocumentCreateModal';
export { default as CreateQueryModal } from './CreateQueryModal';
export { default as CreateQueryManagerModal } from './CreateQueryManagerModal';
export { default as QueryPreviewModal } from './QueryPreviewModal';
export { default as QueryPreviewManagerModal } from './QueryPreviewManagerModal';

export { default as BillingResponseModal } from './BillingResponseModal';
export { default as SelectSeriesModal } from './SelectSeriesModal';
export { default as BussinesPartnerModal } from './bussinesPartnerModal';
export { default as PriceListModal } from './PriceListModal';
export { default as AccountListModal } from './AccountListModal';
export { default as InvoicesPaymentModal } from './InvoicesPaymentModal';
export { default as CheckListModal } from './CheckListModal';
export { default as UserFieldsModal } from './UserFieldsModal';
export { default as UserFieldsPartnerModal } from './UserFieldsPartnerModal';
export { default as GroupCodeModal } from './GroupCodeModal';
export { default as CardCodeReferenceCreationModal } from './CardCodeReferenceCreationModal';
export { default as TerritoriesModal } from './TerritoriesModal';
export { default as CardTypeModal } from './CardTypeModal';
export { default as CurrencyModal } from './CurrencyModal';
export { default as EmployeeSalesPartnerModal } from './EmployeeSalesPartnerModal';
export { default as GroupNumModal } from './GroupNumModal';
export { default as GroupNumbersModal } from './businessPartner/GroupNumbersModal';
export { default as PriceListPartnerModal } from './PriceListPartnerModal';
export { default as AddressesModal } from './AddressesModal';
export { default as ContactPersonsPartnerModal } from './ContactPersonsPartnerModal';
export { default as AddressesPartnerModal } from './AddressesPartnerModal';
export { default as CountryModal } from './CountryModal';
export { default as StatesModal } from './StatesModal';
export { default as ImpuestoPartnerModal } from './ImpuestoPartnerModal';
export { default as PayMethodModal } from './PayMethodModal';
export { default as SelectOfModal } from './SelectOfModal';
export { default as PersonRequestModal } from './UsersModal';
export { default as BranchesModal } from './BranchesModal';
export { default as DepartmentsModal } from './DepartmentsModal';
export { default as InventoryDataModal } from './InventoryDataModal';
export { default as confirmModal } from './confirmModal';
export { default as ContinueModal } from './ContinueModal';
export { default as ValidationBatchsModal } from './ValidationBatchsModal';
export { default as CreditLimitModal } from './CreditLimitModal';
export { default as ValidateItems } from './ValidateItems';
export { default as AccountBalance } from './AccountBalance';
export { default as ProjectsModal } from './ProjectsModal';
export { default as PaymentListModaL } from './PaymentListModaL';
export { default as PaymentStatusListModal } from './PaymentStatusListModal';
export { default as ProjectsPartnerModal } from './ProjectsPartnerModal';

export { default as AuthorizationModel } from './AuthorizationModel';
export { default as AuthorizationModalParnter } from './AuthorizationModalParnter';
export { default as PrintToDocumentsModal } from './PrintToDocumentsModal';
export { default as RenderDocumentHeader } from './RenderDocumentHeader';
export { default as RenderDocumentBody } from './RenderDocumentBody';
export { default as RenderDocumentFooter } from './RenderDocumentFooter';
export { default as RenderConfigHeaderDataTableEnabled } from './RenderConfigHeaderDataTableEnabled';
export { default as RenderConfigUserFieldsEnabled } from './RenderConfigUserFieldsEnabled';
export { default as ConfigItemsDashboardModal } from './ConfigItemsDashboardModal';
export { default as TransactionsModal } from './TransactionsModal';
export { default as BankAccountModal } from './BankAccountModal';
export { default as BankModal } from './BankModal';
export { default as AdministratorUsersModal } from './AdministratorUsersModal';
export { default as ModulesModal } from './ModulesModal';
export { default as SeriesModal } from './SeriesModal';
export { default as ChangePasswordModal } from './ChangePasswordModal';
export { default as ChangeDataMITModal } from './ChangeDataMITModal';
export { default as AreYouAgreeModal } from './AreYouAgreeModal';
export { default as WarningModal } from './WarningModal';
export { default as AddressModal } from './AddressModal'
export { default as NewPriceListModal } from './NewPriceListModal';
export { default as ItemsGroupCodeModal } from './ItemsGroupCodeModal';
//#region Bot settings
export { default as SettingsBot } from './settingsBot/SettingsBot';
export { default as Tooltip } from './ToolTip.js';
//#endregion

export { default as EditCutInventoryModal } from './EditCutInventoryModal';
export { default as RoadMapPreviewModal } from './RoadMapPreviewModal';

export { renderDataTableActions } from './renderDataTableActions';
export { renderTableProjectsModal } from './renderTableProjectsModal'
export { renderTablePartnerModal } from './renderTablePartnerModal';
export { renderTableSeriesModal } from './renderTableSeriesModal';
export { renderTableSeriesModale } from './renderTableSeriesModale';
export { renderTableContactModal } from './renderTableContactModal';
export { renderTableWarehouseModal } from './renderTableWarehouseModal';
export { renderTableEmployeeModal } from './renderTableEmployeeModal';
export { renderTableOwnerModal } from './renderTableOwnerModal';
export { renderTableItemsModal } from './renderTableItemsModal';
export { renderTableItemsProperties } from './renderTableItemsProperties';
export { renderTableTaxesModal } from './renderTableTaxesModal';
export { renderTableCentroCosteModal } from './renderTableCentroCosteModal';
export { renderTablePriceListModal } from './renderTablePriceListModal';
export { renderTableAccountListModal } from './renderTableAccountListModal';
export { renderTableInvoicesPaymentModal } from './renderTableInvoicesPaymentModal';
export { renderTableTransfersModal } from './renderTableTransfersModal';
export { renderTableGroupCodeModal } from './renderTableGroupCodeModal';
export { renderTableCardCodeReferencesModal } from './renderTableCardCodeReferencesModal';
export { renderTableCardTypeModal } from './renderTableCardTypeModal';
export { renderTableCurrencyModal } from './renderTableCurrencyModal';
export { renderGroupNumModal } from './renderGroupNumModal';
export { renderCurrenciesModal } from './renderCurrenciesModal';
export { renderAddressesModal } from './renderAddressesModal';
export { renderTerritoriesModal } from './renderTerritoriesModal';
export { renderContactPersonsPartnerModal } from './renderContactPersonsPartnerModal';
export { renderCountryModal } from './renderCountryModal';
export { renderPayMethodsModal } from './renderPayMethodsModal';
export { renderSelectOfModal } from './renderSelectOfModal';
export { renderTableUomCodeModal } from './renderTableUomCodeModal';

export { renderUsersModal } from './renderUsersModal';
export { renderBranchesModal } from './renderBranchesModal';
export { renderDepartmentsModal } from './renderDepartmentsModal';

export { renderTableOrderSales } from './renderTableOrderSales';
export { renderTableDeliveries } from './renderTableDeliveries';
export { renderTableInvoice } from './renderTableInvoice';
export { renderTableInvoiceAdvance } from './renderTableInvoiceAdvance';
export { renderTablePurchaseDownPayments } from './renderTablePurchaseDownPayments';
export { renderTableReturn } from './renderTableReturn';
export { renderTablePayment } from './renderTablePayment';
export { renderTableTransfers } from './renderTableTransfers';
export { renderTableTransfersRequest } from './renderTableTransfersRequest';
export { renderTableCreditNote } from './renderTableCreditNote';
export { renderTableBorrador } from './renderTableBorrador';
export { renderBussinesPartner } from './renderBussinesPartner';
export { renderTablePurchaseOrder } from './renderTablePurchaseOrder';
export { renderTableGoodsReceipt } from './renderTableGoodsReceipt';
export { renderTableTransactionsModal } from './renderTableTransactionsModal';
export { renderTableAuthorization } from './renderTableAuthorization';
export { renderTablePaymnetListModal } from './renderTablePaymnetListModal';
export { renderTablePaymnetListStatusModal } from './renderTablePaymnetListStatusModal';
export { renderTableMiddleware } from './renderTableMiddleware';

export { renderTablePurchaseRequest } from './renderTablePurchaseRequest';
export { renderInventoryData } from './renderInventoryData';
export { renderTableName } from './renderTableName';
export { renderColumnsName } from './renderColumnsName';
export { renderTableUsers } from './renderTableUsers';
//#region CARTA PORTE
export { renderFiguraTransporte } from './renderFiguraTransporte';
export { renderTransporte } from './renderTransporte';
export { renderCartaPorte } from './renderCartaPorte';
export { renderClaveProdSATModal } from './renderTableClaveProdSAT';
export { renderTableTransporteModal } from './renderTableTransporteModal';
export { renderTableFiguraTransporteModal } from './renderTableFiguraTransporteModal';
export { renderTableFormattedQueriesModal } from './renderTableFormattedQueriesModal';
export { renderTableCutTransfersUsersModal } from './renderTableCutTransfersUsersModal.js';
//#endregion
export { renderPriceLists } from './renderPriceLists';
export { default as ValidationModal } from './ValidationModal';

export { default as SearchBarReports } from './SearchBarReports';
export { default as ReportsBottomInfo } from './ReportsInfo';

export { default as EmployeeModal } from './EmployeeModal';
export { default as SucursalModal } from './SucursalModal';
export { default as ListModal } from './ListModal';
export { default as SearchSucursalModal } from './SearchSucursalModal';
export { default as PartnerCreateModal } from './PartnerCreateModal';
export { default as NewCustomerModal } from './NewCustomerModal';
export { default as ConfigurationPointsCardModal } from './ConfigurationPointsCardModal';
export { default as PointEquivalencePointsCardModal } from './PointEquivalencePointsCardModal';
export { default as PaymentInvoiceCreditPoinstCardModal } from './PaymentInvoiceCreditPoinstCardModal';
export { default as LimitPoinstCardModal } from './LimitPoinstCardModal';
export { default as NotificationPointsCardModal } from './NotificationPointsCardModal';

export { default as PdfViewer } from './PdfViewer';
export { default as exportHTMLToExcel } from './ExportHtmlToCSV';
export { default as DeliveryHouse } from './docsSERDI/deliveryHouse';
export { default as OrderDoc } from './docsSERDI/order';
export { default as DeliveryDoc } from './docsSERDI/delivery';
export { default as CancelInvoice } from './docsSERDI/cancelInvoice';
export { default as InvoiceDoc } from './docsSERDI/invoice';
export { default as AdvancePaymentInvoiceDoc } from './docsSERDI/advancePaymentInvoice';
export { default as CollectInvoice } from './docsSERDI/collectInvoice';
export { default as DownPayment } from './docsSERDI/downPayment';
export { default as CreditNote } from './docsSERDI/creditNote';
export { default as CreditNoteOfCancelation } from './docsSERDI/creditNoteOfCancelation';
export { default as PaymentCancelation } from './docsSERDI/paymentCancelation';
export { default as Quotation } from './docsSERDI/quotation';
export { default as Closures } from './docsSERDI/closures';
export { default as SecretReport } from './docsSERDI/secret';
export { default as BankDeposit } from './docsSERDI/bankDeposit';
export { default as PaymentsReceived } from './docsSERDI/paymentsReceived';
export { default as GeneralModal } from './GeneralModal';
export { default as GeneralFunctions } from './GeneralFunctions';
export { default as Ticket } from './docsSERDI/ticket';
export { default as TicketCanceled } from './docsSERDI/ticketCanceled';
export { default as TicketPaid } from './docsSERDI/ticketPaid';
export { default as MoneyIn } from './docsSERDI/moneyIn';
export { default as MoneyOut } from './docsSERDI/moneyOut';
export { default as RefTicket } from './docsSERDI/refTicket';
export { default as CashCut } from './docsSERDI/cashCut';
export { default as CashCutAlt } from './docsSERDI/cashCutAlt';
export { default as RefundTicket } from './docsSERDI/RefundTicket';
export { default as SearchEmployeeModal } from './SearchEmployeeModal';
export { default as PaymentModal } from './PaymentModal';
export { default as CancelPaymentModal } from './CancelPaymentDateModal';
export { default as JournalEntryModal } from './JournalEntryModal';
export { default as RelationPMBA } from './RelationPMBA';

export { default as CardsListModal } from './CardsListModal';
export { renderTableCardsListModal } from './renderTableCardsListModal';


export { default as FormatRefundTicketModal } from './FormatRefundTicketModal';
export { default as RefundTicketModal } from './RefundTicketModal';
export { default as FormatCanceledTicketModal } from './FormatCanceledTicketModal';
export { default as CommentsModal } from './CommentsModal';
export { default as BatchDefinitionModal } from './BatchDefinitionModal';
export { default as BatchSelectionModal } from './BatchSelectionModal';
export { default as BatchReportModal } from './BatchReportModal';
export { default as AdvancePaymentInvoicesModal } from './AdvancePaymentInvoicesModal';
export { default as FormatAdvancePaymentModal } from './FormatAdvancePaymentModal';
export { default as PaymentCreditCardsModal } from './PaymentCreditCardsModal';
export { default as ClosureModal } from './ClosureModal';
export { default as RefundOfPaymentsModal } from './RefundOfPaymentsModal';
export { default as CancelDocuments } from './CancelDocuments';
export { default as CancelCFDI } from './CancelCFDI';

export { default as ReportSalesModal } from './ReportSalesModal';
export { default as ReportSalesSellerModal } from './ReportSalesSellerModal';
export { default as ReportPurchasingModal } from './ReportPurchasingModal';
export { default as ReportStocksModal } from './ReportStocksModal';
export { default as ReportOperationsModal } from './ReportOperationsModal';
export { default as ReportKardexModal } from './ReportKardexModal';
export { default as ReportItemsSoldsModal } from './ReportItemsSoldsModal';
export { default as ReportCollectModal } from './ReportCollectModal';
export { default as ReportGlobalInvoiceDeliveryModal } from './ReportGlobalInvoiceDeliveryModal';
export { default as ReportReturnCNoteModal } from './ReportReturnCNote';

export { default as Kardex } from './docsSERDI/reportsCounter/kardex';
export { default as Operations } from './docsSERDI/reportsCounter/operations';
export { default as Purchasing } from './docsSERDI/reportsCounter/purchasing';
export { default as Sales } from './docsSERDI/reportsCounter/sales';
export { default as SalesAlt } from './docsSERDI/reportsCounter/salesAlt';
export { default as SalesByDate } from './docsSERDI/reportsCounter/salesByDate';
export { default as SalesSeller } from './docsSERDI/reportsCounter/salesSeller';
export { default as Stocks } from './docsSERDI/reportsCounter/stocks';
export { default as DetailInvoiceR } from './docsSERDI/reportsCounter/detailInvoiceR';
export { default as MoneyMovements } from './moneyMovements';
export { default as DeliverModal } from './DeliverModal';
export { default as DetailPayments } from './docsSERDI/detailPayments';
export { default as DetailsCutInventory } from './docsSERDI/detailsCutInventory';
export { default as PriceWithTaxesModal } from './PriceWithTaxesModal';
export { default as ReportReserveInvoiceModal } from './ReportReserveInvoiceModal';
export { default as SalesPayments } from './docsSERDI/reportsCounter/salesPayments';
export { default as GeneralInvoiceDelivey } from './docsSERDI/reportsCounter/generalInvoiceDelivey';
export { default as NewUpdateModal } from './NewUpdateModal';
export { default as ReturnCNote } from './docsSERDI/reportsCounter/returnCNote';
export { default as CreditWallet } from './docsSERDI/reportsCounter/CreditWallet';
export { default as AccountStatus } from './docsSERDI/reportsCounter/AccountStatus';
export { default as ProductionTreeReport } from './docsSERDI/reportsCounter/ProductionTreeReport';
export { default as ProdOpenDocsReport } from './docsSERDI/reportsCounter/ProdOpenDocsReport';

export { default as ValidateDocFieldsModal } from './ValidateDocFieldsModal';

//#region CARTA PORTE
export { default as FiguraTransporteModal } from './FiguraTransporteModal';
export { default as TransporteModal } from './TransporteModal';
export { default as CartaPorteModal } from './CartaPorteModal';
export { default as ListPartnerModal } from './ListPartnerModal';
export { default as MercanciaPorteModal } from './MercanciaPorteModal';
export { default as AddressesPorteModal } from './AddressesPorteModal';
export { default as confirmModalCartaPorte } from './confirmModalCartaPorte';
//#endregion

//#region phase 2
// newViews
export { renderPendingTimbraDocs } from './renderPendingTimbraDocs';

//newComponents
export { default as UpdateTimbraDocs } from '../components/UpdateTimbraDocs'
export { default as ClaveProdModal } from './ClaveProdModal';
export { default as StandardSelectModal } from './StandardSelectModal';
export { default as SuggestionsList } from './SuggestionsList';
export { ReportCard } from './ReportCard';
export { AppCard } from './AppCard';
//#endregion

// TIMBRADO NOMINAS
export { renderTableNominas } from './renderTimbraNom.js';
export { renderEmployeeNomina } from './renderEmployeeNomina.js';
export { default as NominaModal } from './timbraNominas/nominaModal.js';
export { default as EmployeeNominaModal } from './timbraNominas/EmployeeNominaModal.js';

// TIMBRADO COMERCIO EXTERIOR Y LEYENDAS FISCALES
export { default as ComercioExterior } from './timbra/ComercioExterior.js';

//CITIBANAMEX
export { renderCitibanamex } from './renderCitibanamex';
export { default as VendorsModal } from './VendorsModal';

export { renderTableVendorsModal } from './renderTableVendorsModal';
export { default as CitibanamexTransactionsModal } from './CitibanamexTransactionsModal';


// GENERAL FROM ROUTES
export { default as EventModal } from './adminRoutes/EventModal';
export { default as RoutesModal } from './adminRoutes/RoutesModal';
export { default as FullCalendarCmp } from './adminRoutes/FullCalendarCmp';
export { default as TryMap } from './adminRoutes/TryMap';

export { default as ScheduleRoute } from './adminRoutes/ScheduleRoute';
// SELLERS ROUTES
export { default as Dashboard } from './adminRoutes/Dashboard';
export { default as UpdateRoute } from './adminRoutes/UpdateRoute';
export { default as DeleteRoute } from './adminRoutes/DeleteRoutes';
export { default as CreateRouteSellers } from './adminRoutes/CreateRoute.jsx';
// DELIVERY ROUTES
export { default as DashboardDeliveries } from './adminDeliveries/DashboardDeliveries';
export { default as CreateRoute } from './adminDeliveries/CreateRoute';
export { default as UpdateDeliveryRoute } from './adminDeliveries/UpdateDeliveryRoute';
export { default as CreateRouteR2D2 } from './adminDeliveries/CreateRouteR2D2';
export { default as DocDelivery } from './adminDeliveries/DocDelivery.js';
export { renderAdminDeliveries20 } from './adminDeliveries/renderAdminDeliveries20.js';



// export { renderAdminDrivers } from './renderAdminDrivers';
// export { renderAdminVehicles } from './renderAdminVehicles';
export { renderAuthorizePartners } from './renderAuthorizePartners';

// export { default as DriverModal } from './driverModal';
// export { default as VehicleModal } from './VehicleModal';
export { default as ApproveBusinessPartnerModal } from './ApproveBusinessPartnerModal';

// Notifications 
export { default as NotificationCenter } from './Notifications/NotificationCenter'
export { default as PushNotifications } from './Notifications/PushNotifications'

//#region New Reports Modals
export { default as ReportCreditWalletModal } from './ReportCreditWalletModal';
export { default as ReportAccountStatusModal } from './ReportAccountStatusModal';
export { default as ReportProductionTree } from './ReportProductionTree';
export { default as ReportProdOpenDocs } from './ReportProdOpenDocs.js';
//#endregion
export { default as ListDocsDeliveries } from './ListDocsDeliveries.js';
export { renderPendingDeliveries } from './renderPendingDeliveries.js';
export { default as ToolTip } from './ToolTip.js'

//#region MRP
export { default as CreateForecastModal } from './CreateForecastModal';
export { default as MRPAssistantModal } from './MRPAssistantModal.js';
export { default as MRPAssistanceItems } from './MRP/MRPAssistantItemsModal';
export { default as MRPPeggingModal } from './MRPPeggingModal';
export { renderReportSelectionCriteria } from './renderReportSelectionCriteria.js';
export { renderStandardDataTableDocuments } from './renderStandardDataTableDocuments.js';
export { default as OrderRecommendation } from './OrderRecommendation';
export { renderOrderRecommendationModal } from './renderOrderRecommendationModal.js';
//#endregion

//suggestion List
export { default as SuggestionList } from './SuggestionList';

export { renderTableLandedCosts, ContentLandedCosts } from './renderLandedCosts.js'

// PRODUCTION 
export { default as ContentProductTree } from './renderContentProductTree'
export { default as ContentProductionOrder } from './renderContentProductionOrder'
export { default as ContentGoodsReceiptProd } from './ContentGoodsReceiptProd'
export { default as ContentGoodsIssue } from './ContentGoodsIssue'
export { renderTableListMaterialModal } from './renderTableListMaterialModal';
export { default as ContentProvConfAssistant } from './ContentProvConfAssistant'
export { default as SelectionCriteriaModal } from './selectionCriteriaModal'

// Nuevos para documentos
export { default as NewDocTable } from './CreateDocuments/NewDocTable'
export { default as NewDocCreateModal } from './CreateDocuments/NewDocCreateModal'
export { default as EntryTransfers } from './EntryTransfers';

// Resources
export { default as ContentRscMasterData } from './resourcesModule/ContentRscMasterData'
export { default as ContentRscCapacity } from './resourcesModule/ContentRscCapacity'

export { default as GenericTable } from './genericTable/GenericTable.js';
export { default as ItemsCreateModal } from './ItemsCreateModal.js';



// REFERRAL SYSTEM
export { default as SendReferralPartner } from './referralSystem/SendReferralPartner.js';
export { default as SearchPartnerRefSys } from './referralSystem/SearchPartnerRefSys.js';
export { default as ReferralSystemPerson } from './referralSystem/ReferralSystemPerson.js';
export { default as SettingsAdmin } from './referralSystem/SettingsAdmin.js';
export { default as RequestAmbassadors } from './referralSystem/RequestAmbassadors.js';
export { default as NotificationReferrals } from './Notifications/NotificationsReferrals.js'
export { default as GenericSearchModal } from './GenericSearchModal/GenericSearchModal.js'
// SUGGEST REFILL MODULE
export { renderTableSuggestRefill } from './renderTableSuggestRefill.js'
export { default as SuggestRefillModal } from './SuggestRefillModule/SuggestRefillModal.js';


//M-VENTAS MANAGEMENT
export { renderMVentasAdminUser } from './renderMVentasAdminUser.js';
export { default as MVentasAdminUsersModal } from './MVentasAdminUsersModal.js';
export { default as MVentasModulesModal } from './mVentasModulesModal.js';

export { default as ActiveRoutes } from './adminDeliveries/ActiveRoutes.js'
export { default as SetDocsToDelivery } from './adminDeliveries/SetDocsToDeliveryModal.js';
//END M-VENTAS MANAGEMENT



/**WHS ADMIN */
export { default as WareHouseDetailsModal } from './WareHouseDetailsModal.js';


export { default as ReconciliationModal } from './ReconciliationModal.js';

//#region InventoryCounting
export { default as InventoryCountingCreateModal } from './InventoryCountingCreateModal';
export { renderTableInventoryDocuments } from './renderInventoryDocuments';
//#endregion

export { default as DownPayments } from './DownPayments.js';


//#region Oxxo services
export { default as OxxoReferenceInfo } from './OxxoServices/OxxoReferenceInfo.js';
//#endregion

export { default as TransferRouteModal } from './TransferRouteModal.js';

export { default as PolygonMap } from './PolygonMap';
export { default as NiubizModal } from './counter/NiubizModal';
export { default as LocationAssignment } from './LocationAssignment';
export { default as ListLocationsModal } from './ListLocationsModal';
export { renderTableLocationsAssignment } from './renderTableLocationsAssignment';
export { default as DocumentStockModal } from './DocumentStockModal';
export { default as LocationModal } from './LocationModal';
export { default as CentroCosteModal } from './CentroCosteModal.js';

export { default as TwoStepsVerificationInventoryModal } from './TwoStepsVerificationInventoryModal';
export { default as NavBarCashierResponsive } from './NavBarCashierResponsive.js';
export { default as PrinterConfigurationModal } from './PrinterConfigurationModal.js';
export { default as AppsCashCuts } from './counter/AppsCashCuts';
export { default as CollectDeposits } from './collect/CollectDeposits';
export { renderCollect } from './renderCollect';

export { default as MassiveUsersModal } from './users/MassiveUsersModal.js';
export { default as StandardTable } from './standardComponents/StandardTable.js';
export { renderTableIncomingPayment } from './renderTableIncomingPayment.js';

//#region Modales de reportes
export { default as ReportCierreCajaModal } from './ReportCierreCajaModal.js';
export { default as ReportContrasteCobranzaModal } from './ReportContrasteCobranzaModal.js';
export { default as ReportEstatusFacturasModal } from './ReportEstatusFacturasModal.js';
//#region Reportes
export { default as CierreCaja } from './docsSERDI/reportsCounter/CierreCaja';
export { default as EstatusFacturas } from './docsSERDI/reportsCounter/EstatusFacturas';
export { default as ContrasteCobranza } from './docsSERDI/reportsCounter/ContrasteCobranza';
export { renderTablePurchaseQuotation } from './renderTablePurchaseQuotation';
export { renderTableDraft } from './renderTableDraft';
export { renderTableORDRTransportsModal } from './renderTableORDRTransportsModal';